import { createContext } from "react";

const context = createContext({
  newDownloads: [],
  addPendingDownload: () => {},
  completeDownload: () => {},
  discardPendingDownload: () => {},
  acknowledgeDownload: () => {},
  syncDownloads: () => {},
});

export default context;
